import { addAbsolutePosition } from './utils/addAbsolutePosition';
import { addIndexName } from './utils/addIndexName';
import { addQueryID } from './utils/addQueryID';
import { version } from './version';
export function getRecommendedForYou({
  indexName,
  threshold,
  queryParameters,
  recommendClient,
  maxRecommendations,
  transformItems = x => x
}) {
  recommendClient.addAlgoliaAgent('recommend-core', version);
  const queries = [{
    indexName,
    threshold,
    queryParameters,
    maxRecommendations
  }];
  return recommendClient.getRecommendedForYou(queries).then(response => ({
    recommendations: transformItems(response.results.map(result => result.hits.map(hit => addIndexName(hit, indexName)).map(hit => addQueryID(hit, result.queryID))).flat().map((hit, idx) => addAbsolutePosition(hit, idx)))
  }));
}